import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { Header, Header2, Header3 } from '@app/components/general/header'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { Address } from '@app/components/general/mailto'
import { SUPPORT_EMAIL } from '@app/configs/app-config'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { P } from '@app/components/stateless/typo/p'
import Trans from 'next-translate/Trans'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/careers',
    }),
  }
}

function Careers() {
  const { t } = useTranslation('careers')

  return (
    <MarketingDrawer>
      <div>
        <Header>{t('header')}</Header>
        <Header2>{t('subheader')}</Header2>
        <P>{t('subheader-d')}</P>
        <Header3>{t('how-apply')}</Header3>
        <Trans
          i18nKey='careers:apply-d'
          components={[
            <P key={'c1'} />,
            <Address
              className='underline text-blue-600 hover:text-blue-400 capitalize'
              email={SUPPORT_EMAIL}
              key={'careers-c2'}
            />,
          ]}
        />
      </div>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { Careers },
  {
    translation: 'careers',
  }
)
